import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25, PaymentOptionsMetadata, Quote } from '@sm360/widget-commons-vehicle';
import { InputDropDown } from '@sm360/widget-commons-forms';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import 'payment-calculator-v25/components/Distance/Distance.scss';

const Distance = ({ purchaseMethods, onKMPlanClick, paymentOptionsMetadata, quote, config }) => {
    const kmPlanParameters = purchaseMethods.getSelectedFinanceKMPlanParameters(LocaleService, paymentOptionsMetadata);
    if (!kmPlanParameters.kmPlanOptions) {
        return null;
    }
    const onChange = (kmPlanOption) => {
        onKMPlanClick(kmPlanOption, config);
        AnalyticsService.ga4Trigger(
            TAGS.PAYMENT_CALCULATOR_KM_PLAN(kmPlanOption.label, quote.vehicle.model.name, quote.vehicle.year)
        );
    };

    return (
        <div className="section-distance">
            <div className="distance_title is-light">{LocaleService.t('PAYMENT_CALCULATOR_V25.KMPLANS.TITLE')}</div>
            <InputDropDown
                name="KMPlans"
                options={kmPlanParameters.kmPlanOptions.sort((a, b) => a.value - b.value)}
                value={kmPlanParameters.selectedKMPlan.value}
                valueChange={onChange}
                classNames={['input-dropdown sr-paymentCalculator-dropdown']}
            />
        </div>
    );
};

Distance.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    paymentOptionsMetadata: PropTypes.arrayOf(PropTypes.instanceOf(PaymentOptionsMetadata.PaymentOptionsMetadataModel))
        .isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    onKMPlanClick: PropTypes.func.isRequired,
};

Distance.displayName = 'Distance';

export default Distance;
